import React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from 'antd';
import CustomButton from '../../../shared/custom-button/custom-button';
import './smart-policy-modal.scss';
import { useStores } from '../../../store';
import { EventType } from '../../../../dtos/analytics.dto';
import { SystemConfiguration } from 'src/utils/system-configuration';
import { BackToPolicySelection } from '../../../shared/back-to-policy-selection/back-to-policy-selection';

interface SmartPolicyModalProps {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
}

export const SmartPolicyModal: React.FC<SmartPolicyModalProps> = observer(({ visible, setIsVisible }) => {
    const { customerStore, fwVersionStore } = useStores();

    const title = 'We have started analyzing your network traffic.';
    const subTitle = `Analysis needs ${SystemConfiguration.getInstance().policyGeneratorAnalysisDays} days of service.
     You will be notified by email once completed.`;

    const onGotIt = () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked,
            { button: 'continue', location: 'smartPolicyModal' });
        setIsVisible(false);
    };

    return <Modal open={visible} className="smart-policy-modal" width={680} closable={false} footer={null} centered>
        <div className="smart-policy-content">
            <div className="smart-policy-title">{title}</div>
            <div className="smart-policy-subtitle">{subTitle}</div>
            <div className="smart-policy-footer">
                {!customerStore.isSmartPolicyDraftReady && <BackToPolicySelection buttonLocation="smartPolicyModal" />}
                <CustomButton className="primary-btn btn-got-it" label="Continue" onClick={onGotIt} />
            </div>
        </div>
    </Modal>;
});
